import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, MapPin, Phone, Mail, Edit3, Save, Plus, Trash2, LogOut, Package, Heart } from 'lucide-react';
import Header from './components/Header23';
import Footer from './components/Footer23';

const Template23Profile = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('profile');
    const [isEditing, setIsEditing] = useState(false);
    const [profileData, setProfileData] = useState({
        firstName: 'Priya',
        lastName: 'Sharma',
        email: 'priya.sharma@email.com',
        phone: '+91 98765 43210',
        dateOfBirth: '1995-06-15',
        gender: 'female',
    });
    const [addresses, setAddresses] = useState([
        {
            id: 1,
            label: 'Home',
            name: 'Priya Sharma',
            address: '42, Rose Garden Colony',
            city: 'Jaipur',
            state: 'Rajasthan',
            pincode: '302001',
            phone: '+91 98765 43210',
            isDefault: true,
        },
        {
            id: 2,
            label: 'Office',
            name: 'Priya Sharma',
            address: '15, Business Hub Tower, 3rd Floor',
            city: 'Mumbai',
            state: 'Maharashtra',
            pincode: '400001',
            phone: '+91 98765 43211',
            isDefault: false,
        },
    ]);

    const handleChange = (e) => {
        setProfileData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const tabs = [
        { value: 'profile', label: 'Profile', icon: <User size={16} /> },
        { value: 'addresses', label: 'Addresses', icon: <MapPin size={16} /> },
    ];

    const inputStyle = {
        width: '100%',
        padding: '14px 16px',
        border: '1px solid #E8E0D4',
        borderRadius: '8px',
        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
        fontSize: '14px',
        color: '#1B3A2D',
        backgroundColor: isEditing ? '#FFFDF8' : '#F8F3EC',
        outline: 'none',
        transition: 'all 0.3s ease',
        boxSizing: 'border-box',
    };

    const labelStyle = {
        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
        fontSize: '13px',
        fontWeight: 600,
        color: '#1B3A2D',
        display: 'block',
        marginBottom: '6px',
    };

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Nunito+Sans:wght@300;400;500;600;700&display=swap');

                .utsav-profile-layout {
                    display: flex;
                    flex-direction: column;
                    gap: 32px;
                    max-width: 1000px;
                    margin: 0 auto;
                    padding: 120px 24px 80px;
                }
                @media (min-width: 768px) {
                    .utsav-profile-layout {
                        flex-direction: row;
                        gap: 40px;
                        padding: 140px 24px 80px;
                    }
                }
                .utsav-profile-sidebar {
                    width: 100%;
                }
                @media (min-width: 768px) {
                    .utsav-profile-sidebar {
                        width: 260px;
                        flex-shrink: 0;
                    }
                }
                .utsav-profile-content {
                    flex: 1;
                }
                .utsav-profile-form-row {
                    display: grid;
                    grid-template-columns: 1fr;
                    gap: 16px;
                    margin-bottom: 16px;
                }
                @media (min-width: 480px) {
                    .utsav-profile-form-row {
                        grid-template-columns: 1fr 1fr;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FFFDF8' }}>
                <Header cartCount={0} />

                <div className="utsav-profile-layout">
                    {/* Sidebar */}
                    <div className="utsav-profile-sidebar">
                        <div style={{
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            padding: '24px',
                            boxShadow: '0 2px 12px rgba(27, 58, 45, 0.06)',
                            textAlign: 'center',
                            marginBottom: '16px',
                        }}>
                            <div style={{
                                width: '80px',
                                height: '80px',
                                borderRadius: '50%',
                                background: 'linear-gradient(135deg, #1B3A2D, #2D5A45)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                margin: '0 auto 16px',
                            }}>
                                <span style={{
                                    fontFamily: "'Libre Baskerville', Georgia, serif",
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#C5974B',
                                }}>
                                    {profileData.firstName[0]}{profileData.lastName[0]}
                                </span>
                            </div>
                            <h2 style={{
                                fontFamily: "'Libre Baskerville', Georgia, serif",
                                fontSize: '18px',
                                fontWeight: 700,
                                color: '#1B3A2D',
                                margin: '0 0 4px 0',
                            }}>
                                {profileData.firstName} {profileData.lastName}
                            </h2>
                            <p style={{
                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                fontSize: '13px',
                                color: '#5A5A5A',
                                margin: 0,
                            }}>
                                {profileData.email}
                            </p>
                        </div>

                        {/* Navigation */}
                        <div style={{
                            backgroundColor: '#FFFFFF',
                            borderRadius: '16px',
                            overflow: 'hidden',
                            boxShadow: '0 2px 12px rgba(27, 58, 45, 0.06)',
                        }}>
                            {tabs.map(tab => (
                                <button
                                    key={tab.value}
                                    onClick={() => setActiveTab(tab.value)}
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        padding: '14px 20px',
                                        backgroundColor: activeTab === tab.value ? '#F8F3EC' : 'transparent',
                                        border: 'none',
                                        borderLeft: activeTab === tab.value ? '3px solid #C5974B' : '3px solid transparent',
                                        cursor: 'pointer',
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '14px',
                                        fontWeight: activeTab === tab.value ? 600 : 400,
                                        color: activeTab === tab.value ? '#1B3A2D' : '#5A5A5A',
                                        transition: 'all 0.3s ease',
                                        textAlign: 'left',
                                    }}
                                >
                                    {tab.icon}
                                    {tab.label}
                                </button>
                            ))}
                            <button
                                onClick={() => navigate('/template23/orders')}
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '14px 20px',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    borderLeft: '3px solid transparent',
                                    cursor: 'pointer',
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#5A5A5A',
                                    textAlign: 'left',
                                }}
                            >
                                <Package size={16} />
                                My Orders
                            </button>
                            <button
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    padding: '14px 20px',
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    borderLeft: '3px solid transparent',
                                    borderTop: '1px solid #F8F3EC',
                                    cursor: 'pointer',
                                    fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                    fontSize: '14px',
                                    color: '#7A1B3B',
                                    textAlign: 'left',
                                }}
                            >
                                <LogOut size={16} />
                                Sign Out
                            </button>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="utsav-profile-content">
                        {activeTab === 'profile' && (
                            <div style={{
                                backgroundColor: '#FFFFFF',
                                borderRadius: '16px',
                                padding: '32px',
                                boxShadow: '0 2px 12px rgba(27, 58, 45, 0.06)',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '28px',
                                }}>
                                    <h2 style={{
                                        fontFamily: "'Libre Baskerville', Georgia, serif",
                                        fontSize: '22px',
                                        fontWeight: 700,
                                        color: '#1B3A2D',
                                        margin: 0,
                                    }}>
                                        Personal Information
                                    </h2>
                                    <button
                                        onClick={() => setIsEditing(!isEditing)}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '6px',
                                            padding: '8px 16px',
                                            backgroundColor: isEditing ? '#C5974B' : 'transparent',
                                            color: isEditing ? '#FFFFFF' : '#C5974B',
                                            border: isEditing ? 'none' : '1px solid #C5974B',
                                            borderRadius: '8px',
                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                            fontSize: '13px',
                                            fontWeight: 600,
                                            cursor: 'pointer',
                                        }}
                                    >
                                        {isEditing ? <><Save size={14} /> Save</> : <><Edit3 size={14} /> Edit</>}
                                    </button>
                                </div>

                                <div className="utsav-profile-form-row">
                                    <div>
                                        <label style={labelStyle}>First Name</label>
                                        <input
                                            type="text"
                                            name="firstName"
                                            value={profileData.firstName}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={inputStyle}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Last Name</label>
                                        <input
                                            type="text"
                                            name="lastName"
                                            value={profileData.lastName}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={inputStyle}
                                        />
                                    </div>
                                </div>

                                <div className="utsav-profile-form-row">
                                    <div>
                                        <label style={labelStyle}>Email Address</label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={profileData.email}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={inputStyle}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Phone Number</label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={profileData.phone}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={inputStyle}
                                        />
                                    </div>
                                </div>

                                <div className="utsav-profile-form-row">
                                    <div>
                                        <label style={labelStyle}>Date of Birth</label>
                                        <input
                                            type="date"
                                            name="dateOfBirth"
                                            value={profileData.dateOfBirth}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={inputStyle}
                                        />
                                    </div>
                                    <div>
                                        <label style={labelStyle}>Gender</label>
                                        <select
                                            name="gender"
                                            value={profileData.gender}
                                            onChange={handleChange}
                                            disabled={!isEditing}
                                            style={{
                                                ...inputStyle,
                                                appearance: 'none',
                                                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%23C5974B' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'right 12px center',
                                            }}
                                        >
                                            <option value="female">Female</option>
                                            <option value="male">Male</option>
                                            <option value="other">Other</option>
                                            <option value="prefer-not">Prefer not to say</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        )}

                        {activeTab === 'addresses' && (
                            <div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '20px',
                                }}>
                                    <h2 style={{
                                        fontFamily: "'Libre Baskerville', Georgia, serif",
                                        fontSize: '22px',
                                        fontWeight: 700,
                                        color: '#1B3A2D',
                                        margin: 0,
                                    }}>
                                        Saved Addresses
                                    </h2>
                                    <button style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '8px 16px',
                                        backgroundColor: '#1B3A2D',
                                        color: '#FFFFFF',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        cursor: 'pointer',
                                    }}>
                                        <Plus size={14} />
                                        Add Address
                                    </button>
                                </div>

                                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                                    {addresses.map(addr => (
                                        <div
                                            key={addr.id}
                                            style={{
                                                backgroundColor: '#FFFFFF',
                                                borderRadius: '14px',
                                                padding: '24px',
                                                boxShadow: '0 2px 12px rgba(27, 58, 45, 0.06)',
                                                border: addr.isDefault ? '2px solid #C5974B' : '1px solid #E8E0D4',
                                            }}
                                        >
                                            <div style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                marginBottom: '12px',
                                            }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{
                                                        fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                        fontSize: '14px',
                                                        fontWeight: 700,
                                                        color: '#1B3A2D',
                                                    }}>
                                                        {addr.label}
                                                    </span>
                                                    {addr.isDefault && (
                                                        <span style={{
                                                            fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                            fontSize: '10px',
                                                            fontWeight: 700,
                                                            letterSpacing: '0.5px',
                                                            textTransform: 'uppercase',
                                                            color: '#C5974B',
                                                            backgroundColor: '#FFF9F0',
                                                            padding: '3px 8px',
                                                            borderRadius: '4px',
                                                        }}>
                                                            Default
                                                        </span>
                                                    )}
                                                </div>
                                                <div style={{ display: 'flex', gap: '8px' }}>
                                                    <button style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        padding: '4px',
                                                    }}>
                                                        <Edit3 size={16} color="#C5974B" />
                                                    </button>
                                                    <button style={{
                                                        backgroundColor: 'transparent',
                                                        border: 'none',
                                                        cursor: 'pointer',
                                                        padding: '4px',
                                                    }}>
                                                        <Trash2 size={16} color="#7A1B3B" />
                                                    </button>
                                                </div>
                                            </div>
                                            <p style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                color: '#1B3A2D',
                                                margin: '0 0 4px 0',
                                            }}>
                                                {addr.name}
                                            </p>
                                            <p style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '14px',
                                                color: '#5A5A5A',
                                                lineHeight: 1.6,
                                                margin: '0 0 8px 0',
                                            }}>
                                                {addr.address}<br />
                                                {addr.city}, {addr.state} - {addr.pincode}
                                            </p>
                                            <p style={{
                                                fontFamily: "'Nunito Sans', -apple-system, sans-serif",
                                                fontSize: '13px',
                                                color: '#5A5A5A',
                                                margin: 0,
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '6px',
                                            }}>
                                                <Phone size={13} />
                                                {addr.phone}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template23Profile;
